import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import MovieList from './components/MovieList';
import MovieDetail from './components/MovieDetail';
import BookList from './components/BookList';
import BookDetail from './components/BookDetail';
import { DataProvider } from './context/DataContext';
import './App.css';

function App() {
  return (
    <DataProvider>
      <Router>
        <div className="App">
          <Navigation />
          <Routes>
            <Route path="/" element={<MovieList />} />
            <Route path="/movie/:id" element={<MovieDetail />} />
            <Route path="/books" element={<BookList />} />
            <Route path="/book/:id" element={<BookDetail />} />
            <Route path="/book/*" element={<BookDetail />} />
          </Routes>
        </div>
      </Router>
    </DataProvider>
  );
}

export default App;
